/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RegisterDenyType {
  REQUEST_CHANGES = 'REQUEST_CHANGES',
  INDEFINITE = 'INDEFINITE',
  TEMPORARILY = 'TEMPORARILY',
}
